import { IAutocompleteNeighbourhood } from 'utils/entities';
import { CompareListItems } from './types';

export const enhanceList = (
  items: IAutocompleteNeighbourhood[],
  matchedListings: Array<{
    neighborhoodDocId: string;
    matchedListingsCount: number;
  }>
): CompareListItems => {
  const listingsCount = Object.fromEntries((matchedListings || []).map(o => [ o.neighborhoodDocId, o.matchedListingsCount ]));
  return items.map(i => ({ ...i, listingCount: listingsCount[i.docId] || undefined }));
};
